import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import NuestrosProductos from '../../../media/img/products/2150038851.jpg';
import Elegirnos from '../../../media/img/products/Desarrollo_daroma.jpg';
import './productsInfoCompany.scss';

const ProductoInfoCompany = () => {
    const { t } = useTranslation();
    const imageRefs = useRef([]);
    const lineRefs = useRef([]);
    const parRefs = useRef([]);

    useEffect(() => {
    const observerOptions = {
        threshold: 0.2,
        rootMargin: '0px 0px 0px 0px'
    };

    const imageObservers = imageRefs.current.map((imgRef) => {
        if (!imgRef) return null;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const direction = entry.target.dataset.direction;
                    entry.target.classList.add(`product-info__image--${direction}-visible`);
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);

        observer.observe(imgRef);
        return observer;
    });

    const lineObservers = lineRefs.current.map((lineRef) => {
        if (!lineRef) return null;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('content__title-line--visible');
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);

        observer.observe(lineRef);
        return observer;
    });

    const parObservers = parRefs.current.map((parRef) => {
        if (!parRef) return null;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('product-info__text--visible');
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);

        observer.observe(parRef);
        return observer;
    });

    return () => {
        imageObservers.forEach(obs => obs?.disconnect());
        lineObservers.forEach(obs => obs?.disconnect());
        parObservers.forEach(obs => obs?.disconnect());
    };
}, []);

    return (
        <div className="product-info">

            <section className="product-info__section">
                <div className="product-info__image-container">
                    <img 
                        ref={el => imageRefs.current[0] = el}
                        data-direction="right"
                        className="product-info__image product-info__image--right" 
                        src={Elegirnos} 
                        alt={t('products.company.title')} 
                    />
                </div>
                <div className="product-info__content">
                    <h1 className="product-info__title content__title-backgroundWhite">{t('products.company.title')}</h1>
                    <div 
                        ref={el => lineRefs.current[0] = el}
                        className="content__title-line" 
                    />
                    <div  
                        ref={el => parRefs.current[0] = el}
                        className="product-info__text product-info__text--hidden"
                    >
                        <p className='content__text-title-backgroundWhite'>
                            {t('products.company.desc1')}
                        </p>
                        <p className='content__text-title-backgroundWhite'>
                            {t('products.company.desc2')}
                        </p>
                        
                    </div>

                </div>
            </section>

            <hr className="divider dividermedia" />

            <section className="product-info__section product-info__section--reverse">
                <div className="product-info__content">
                    <h1 className="product-info__title content__title-backgroundWhite">{t('products.company.whyTitle')}</h1>
                    <div 
                        ref={el => lineRefs.current[1] = el}
                        className="content__title-line" 
                    />
                    <div  
                        ref={el => parRefs.current[1] = el}
                        className="product-info__text product-info__text--hidden"
                    >   
                        <p className='content__text-title-backgroundWhite'>
                            {t('products.company.whyDesc1')}
                        </p>
                        <p className='content__text-title-backgroundWhite'>
                            {t('products.company.whyDesc2')}
                        </p>
                    </div>
                </div>
                <div className="product-info__image-container">
                    <img 
                        ref={el => imageRefs.current[1] = el}
                        data-direction="left"
                        className="product-info__image product-info__image--left" 
                        src={NuestrosProductos} 
                        alt={t('products.company.whyTitle')} 
                    />
                </div>
            </section>
        </div>
    );
};

export default ProductoInfoCompany;